import { render, staticRenderFns } from "./specInfo.vue?vue&type=template&id=e481c7d2&"
import script from "./specInfo.vue?vue&type=script&lang=js&"
export * from "./specInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports